import AllOrdersTable from "../../AllOrdersTable/AllOrdersTable";

// Orders.jsx
const Orders = ({role}) => {


  
  return (<>

<AllOrdersTable/>

  </>
)};

export default Orders;